import useCheckboxPreset, { TCheckboxPresets } from './useCheckboxPreset'

export type { TCheckboxPresets }
export { useCheckboxPreset }
